import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../api/server";
import { LOGIN_USER_API, LOGOUT_USER_API } from "../../api/apiPath";

export const logoutUser = createAsyncThunk(
  "user/logoutUser",
  async ({ userId, userIdentifier }, thunkAPI) => {
    try {
      const response = await http.post(LOGOUT_USER_API, null, {
        params: {
          userId,
          userIdentifier,
        },
      });
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const loginUser = createAsyncThunk(
  "user/loginUser",
  async (userCred) => {
    try {
      const response = await http.post(LOGIN_USER_API, userCred);
      if (response.status === 400) {
        const errorData = await response.json();
        throw new Error(errorData?.data?.message || "Something went wrong!");
      }
      const data = await response?.data;
      data.userEmail = userCred.email;
      return data;
    } catch (error) {
      throw new Error(error?.data?.message || "Something went wrong!");
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    userObj: null,
  },
  reducers: {
    clearUser: (state) => {
      state.userObj = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.userObj = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.userObj = action.payload;
      })
      .addCase(loginUser.rejected, (state) => {
        state.userObj = null;
      });
    builder
      .addCase(logoutUser.fulfilled, (state) => {
        state.userObj = null;
      })
      .addCase(logoutUser.rejected, (state) => {
        state.userObj = null; // still clear even if API fails
      });
  },
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
